import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormFile,
  BFormTextarea,
  BFormCheckbox,
  BButton,
} from "bootstrap-vue";
import Ckeditor from "@@/core/components/shared/Ckeditor/Ckeditor";

export default {
  name: "Popup",
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    Ckeditor,
    BFormFile,
    BFormTextarea,
    BFormCheckbox,
    BButton,
  },
  data() {
    return {
      popupId: null,
      existingImageUrl: null,
      loading: true,
      disabled: false,
      form: {
        title: "",
        description: "",
        image: null,
        is_active: true,
        coupon_code: [],
        display_delay: 0,
        start_date: "",
        end_date: "",
      },
    };
  },
  mounted() {
    this.fetchPopup();
  },
  methods: {
    async fetchPopup() {
      this.loading = true;
      try {
        const response = await this.$axios.get("/admin/popups");
        const list = this.extractList(response.data);
        if (list && list.length > 0) {
          this.popupId = list[0].id;
          this.populateForm(list[0]);
          await this.loadPopupForEdit();
        }
      } catch (error) {
        this.$root.notify(error);
      } finally {
        this.loading = false;
      }
    },
    extractList(payload) {
      if (!payload) return [];
      const data = payload.data ?? payload;
      if (Array.isArray(data)) return data;
      if (data.popups) {
        if (Array.isArray(data.popups)) return data.popups;
        if (Array.isArray(data.popups.data)) return data.popups.data;
      }
      if (Array.isArray(data.data)) return data.data;
      return [];
    },
    extractItem(payload) {
      if (!payload) return null;
      const data = payload.data ?? payload;
      return data.popup ?? data;
    },
    async loadPopupForEdit() {
      try {
        const response = await this.$axios.get(`/admin/popups/${this.popupId}/edit`);
        const popup = this.extractItem(response.data);
        if (!popup) return;
        this.populateForm(popup);
      } catch (error) {
        this.$root.notify(error);
      }
    },
    populateForm(popup) {
      this.form.title = popup.title || "";
      this.form.description = popup.description || "";
      this.form.is_active = !!Number(popup.is_active);
      this.form.coupon_code = this.normalizeCouponCode(popup.coupon_code);
      this.form.display_delay = popup.display_delay ?? 0;
      this.form.start_date = popup.start_date || "";
      this.form.end_date = popup.end_date || "";
      this.existingImageUrl = popup.image
        ? popup.image_url || popup.image
        : null;
    },
    // پشتیبانی از چند حالت پاسخ بک‌اند:
    // - آرایه آبجکت: [{code, description}, ...]
    // - مپ کد=>توضیحات (همون چیزی که بک‌اند فعلی با array_column ذخیره می‌کنه): {"SUMMER20":"desc1","WELCOME10":"desc2"}
    // - آبجکت با کلید عددی: {0:{code,description}, 1:{...}}
    // - آرایه رشته‌ای قدیمی: ["ABC123", "DEF456"]
    // - رشته JSON
    normalizeCouponCode(value) {
      if (!value) return [];

      if (typeof value === "string") {
        try {
          value = JSON.parse(value);
        } catch (e) {
          return [];
        }
      }

      if (Array.isArray(value)) {
        return value.map((item) => this.couponItemToObject(item)).filter(Boolean);
      }

      if (typeof value === "object") {
        const values = Object.values(value);
        if (values.length === 0) return [];

        // اگه همه‌ی مقادیر رشته باشن، یعنی همون فرمت map کد=>توضیحاته
        const isCodeDescriptionMap = values.every((v) => typeof v === "string");
        if (isCodeDescriptionMap) {
          return Object.entries(value).map(([code, description]) => ({
            code,
            description,
          }));
        }

        // در غیر این صورت، آبجکتیه با کلید عددی که مقادیرش خودشون {code, description} هستن
        return values.map((item) => this.couponItemToObject(item)).filter(Boolean);
      }

      return [];
    },
    couponItemToObject(item) {
      if (item && typeof item === "object") {
        return {
          _uid: this.generateCouponUid(),
          code: item.code || "",
          description: item.description || "",
        };
      }
      if (typeof item === "string") {
        return { _uid: this.generateCouponUid(), code: item, description: "" };
      }
      return null;
    },
    generateCouponUid() {
      this._couponUidCounter = (this._couponUidCounter || 0) + 1;
      return `coupon-${Date.now()}-${this._couponUidCounter}`;
    },
    addCoupon() {
      this.form.coupon_code.push({
        _uid: this.generateCouponUid(),
        code: "",
        description: "",
      });
    },
    removeCoupon(uid) {
      const index = this.form.coupon_code.findIndex((c) => c._uid === uid);
      if (index !== -1) {
        this.form.coupon_code.splice(index, 1);
      }
    },
    setImage(e) {
      const file = e.target.files[0];
      if (file) {
        this.form.image = file;
        this.existingImageUrl = URL.createObjectURL(file);
      }
    },
    async submitHandler() {
      this.disabled = true;
      const fd = new FormData();
      fd.append("title", this.form.title || "");
      fd.append("description", this.form.description || "");
      fd.append("display_delay", this.form.display_delay ?? 0);
      fd.append("is_active", this.form.is_active ? 1 : 0);
      fd.append("start_date", this.form.start_date || "");
      fd.append("end_date", this.form.end_date || "");

      // فقط کدهایی که واقعاً پر شدن (خالی کامل رو فیلتر می‌کنیم)
      const coupons = (this.form.coupon_code || []).filter(
        (c) => (c.code && c.code.trim()) || (c.description && c.description.trim())
      );
      coupons.forEach((coupon, index) => {
        fd.append(`coupon_code[${index}][code]`, coupon.code || "");
        fd.append(`coupon_code[${index}][description]`, coupon.description || "");
      });

      if (this.form.image instanceof File) {
        fd.append("image", this.form.image);
      }

      try {
        let response;
        if (this.popupId) {
          fd.append("_method", "PUT");
          response = await this.$axios.post(`/admin/popups/${this.popupId}`, fd);
        } else {
          response = await this.$axios.post("/admin/popups", fd);
          const saved = this.extractItem(response.data);
          if (saved && saved.id) {
            this.popupId = saved.id;
          }
        }
        this.$root.notify(response.data.message, "success");
        await this.loadPopupForEdit();
      } catch (error) {
        this.$root.notify(error);
      } finally {
        this.disabled = false;
      }
    },
  },
};